import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { first, map, tap } from 'rxjs/operators';
import { ManagementStoreActions, ManagementStoreStates } from '../management-store';
import { RouterStoreStates } from '../router';

@Injectable()
export class ManagementResolver {
  constructor(
    private readonly managementStore: Store<ManagementStoreStates.ManagementTokens>,
    private readonly routerStore: Store<RouterStoreStates.RouterState>
  ) {}

  resolve(): Observable<boolean> {
    return this.routerStore.pipe(
      tap(() => {
        this.managementStore.dispatch(ManagementStoreActions.ManagementTokensVppResolverActions.requested());
      }),
      tap(() => {
        this.managementStore.dispatch(ManagementStoreActions.ManagementTokensDepResolverActions.requested());
      }),
      tap(() => {
        this.managementStore.dispatch(ManagementStoreActions.ManagementTokensPushResolverActions.requested());
      }),
      tap(() => {
        this.managementStore.dispatch(ManagementStoreActions.ManagementTokensVendorResolverActions.requested());
      }),
      map(() => true),
      first()
    );
  }
}
